import React from 'react';
import { KatAlert } from '@amzn/katal-react';

const QUICKSIGHT_URL = 'https://us-east-1.quicksight.aws.amazon.com/sn/account/amazonbi/dashboards/b3a365da-8e19-4eb7-8eaf-9b1f02c6e6bd/sheets/b3a365da-8e19-4eb7-8eaf-9b1f02c6e6bd_f12f52f2-4f2f-4fc5-b97d-54f3fd8da6af';

export const FlashBriefingBanner: React.FC = () => (
    <div className='pl-2 pr-3'>
        <KatAlert variant='info'>
            <span slot='header'>Flash briefing cards are no longer available.</span>
            View them on <a href={QUICKSIGHT_URL} target='_blank' rel='noopener noreferrer'>QuickSight</a>.
        </KatAlert>
    </div>
);
